import { EventParams } from 'types/Analytics';

export const getSelectVariantPayload = (
  sourceVariantId: EventParams['select_variant']['source_variant_id'],
  targetVariantId: EventParams['select_variant']['target_variant_id']
): EventParams['select_variant'] => ({
  source_variant_id: sourceVariantId,
  target_variant_id: targetVariantId,
});
